import wujiFetch from '@/utils/wujiFetch';
import getXyManagePathPrefix from '@utils/getXyManagePathPrefix';

const fetchCollection = async ({ projectId, collectionId }) => await wujiFetch(`${getXyManagePathPrefix()}/datasource/collection/${collectionId}?projectid=${projectId}`);

export default {
  fetchCollection,
};
